import React, { useState } from "react";
import "./ProjectLanguages.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function ProjectLanguages(props) {
  const [showAll, setShowAll] = useState(false);
  const initialDisplayCount = 4; // Number of icons to show initially

  // Determine if we need to show the "more" button
  const hasMoreLanguages =
    props.logos && props.logos.length > initialDisplayCount;

  // Get the logos to display based on the showAll state
  const displayLogos = showAll
    ? props.logos
    : props.logos?.slice(0, initialDisplayCount) || [];

  // Prevent default behavior to stop page scrolling
  const preventScroll = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons-languages">
          {displayLogos.map((logo) => {
            return (
              <OverlayTrigger
                key={logo.name}
                placement={"top"}
                overlay={
                  <Tooltip id={`tooltip-top`} className="fixed-tooltip">
                    <strong>{logo.name}</strong>
                  </Tooltip>
                }
                rootClose={true}
              >
                <li
                  className="software-skill-inline-languages"
                  name={logo.skillName}
                  onMouseEnter={preventScroll}
                  onClick={preventScroll}
                >
                  <span
                    className="iconify"
                    data-icon={logo.iconifyClass}
                    data-inline="false"
                  ></span>
                </li>
              </OverlayTrigger>
            );
          })}

          {/* Show "more" button if there are more languages */}
          {hasMoreLanguages && !showAll && (
            <li
              className="software-skill-inline-languages more-button"
              onClick={() => setShowAll(true)}
              title={`${props.logos.length - initialDisplayCount} more`}
            >
              +{props.logos.length - initialDisplayCount}
            </li>
          )}

          {/* Show "less" button if expanded */}
          {showAll && hasMoreLanguages && (
            <li
              className="software-skill-inline-languages less-button"
              onClick={() => setShowAll(false)}
            >
              -
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default ProjectLanguages;
